module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Birrwil-b952f6613b860c422ad40c532f269939.svg";